import styled from "@emotion/styled";
import colors from "styles/colors";
import { BACKGROUND_GRAY_COLOR_NAME, BRAND_BLACK_TEXT_COLOR } from "styles/color-consts";

const SEPARATOR_LINE_COLOR = "#d9d9d9";

export const StyledProductsSwitcher = styled.div`
  padding: 24px;

  .main-products-title-wrapper {
    margin-bottom: 16px;

    .main-product-title {
      font-size: 0.875rem;
      color: ${colors[BRAND_BLACK_TEXT_COLOR]};
      font-weight: 400;
    }
  }

  .main-products-wrapper {
    display: flex;
    flex-direction: column;
  }

  .separator-line {
    margin: 16px 0 24px 0;
    height: 1px;
    background-color: ${SEPARATOR_LINE_COLOR};
  }

  .additional-products-title {
    font-size: 0.875rem;
    font-weight: 400;
    color: ${colors.asphalt};
    margin-bottom: 16px;
  }

  .additional-products-wrapper {
    display: flex;
    flex-direction: row;

    .product {
      .icon-wrapper {
        .picture-component {
          display: flex;
          height: 20px;
          width: 20px;
        }
      }
    }
  }

  .product {
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: 0.875rem;
    font-weight: 400;
    color: ${colors.asphalt};
    padding: 8px;
    border-radius: 8px;
    text-decoration: none;

    .icon-wrapper {
      .picture-component {
        display: flex;
        height: 32px;
        width: 32px;
      }
    }

    :hover {
      background-color: ${colors[BACKGROUND_GRAY_COLOR_NAME]};
    }
  }
`;
